// extracted by mini-css-extract-plugin
export default {"dim":"Sidebar_dim__l84zh","sidebar":"Sidebar_sidebar__Yd2iS","logo":"Sidebar_logo__gNtIJ","title":"Sidebar_title__YrZLL","list":"Sidebar_list__dumUG","item":"Sidebar_item__jnr+m"};